export default "__VITE_ASSET__b7d04311__"